export class LoadSearchCountAction {
    static readonly type = '[SearchCount-get] Get search count';
}
